/**
 * Created by pandemio on 3/26/19.
 */
import React from 'react';
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Form, Button
} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTags} from '@fortawesome/free-solid-svg-icons';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
import CouponDataTable from '../datatables/coupon-data-table';
import ModalCouponManager from '../modals/modal-coupon-manager';
import ApiCalls from "../../custom-classes/api-calls";

// This is the item list
class CouponSearch extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            didMount: false,
            couponId: null,
            loading: false,
            showModal: false,
            showCouponsModal: false,
            propsModal: null,
            redoSearch: false,
            coupon: null
        };
        this.props.addTranslation(global);

        this.handleCouponSelection = this.handleCouponSelection.bind(this);
        this.handleNewCoupon = this.handleNewCoupon.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleUpdateModal = this.toggleUpdateModal.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.setState({didMount: true});
        this.resize();
    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }

    /** Toggle the update plan modal **/
    toggleUpdateModal(e){

        this.setState({
            showCouponsModal: !e,
            redoSearch: true
        });
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    handleCouponSelection(e) {
        // Search the data
        let apiCall = ApiCalls.getCoupons(
            null,
            null,
            null,
            null,
            e,
            1,
            1);
        apiCall.then((data)=> {

            this.setState({
                coupon: data.Coupons[0],
                showCouponsModal: true
            });
        });
    }

    handleNewCoupon(){
        this.setState({
            showCouponsModal: true,
            coupon: null
        })
    }

    /**
     * Renders the main page
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}

                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faTags}/>{' '}
                            <Translate id="coupons-manager.coupons"/>
                        </h2>
                        <small className="white-text">
                            <Translate id="coupons-manager.coupons-search-instruction"/>
                        </small>
                        <hr/>
                        <Button color="warning" onClick={this.handleNewCoupon}>
                            <Translate id="coupons-manager.add-new-coupon"/>
                        </Button>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-white">
                                    <CardBody>
                                        <Form>
                                            <CouponDataTable redoSearch={this.state.redoSearch}
                                                           updateParent={this.handleCouponSelection}/>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <hr/>
                    </Container>
                </div>
                <Footer/>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ?
                    <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
                {this.state.showCouponsModal ?
                    <ModalCouponManager coupon={this.state.coupon}
                                visible={this.state.showCouponsModal}
                                         updateParent={this.toggleUpdateModal}/> : null
                }
            </div>
        )
    };
}

export default withLocalize(CouponSearch);